"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreatePortalSessionMutation = exports.useGetBillingSummaryQuery = exports.billingApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var api_url_1 = require("../../utils/api-url");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.billingApi = (0, react_1.createApi)({
    reducerPath: "billingApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["billing"],
    endpoints: function (builder) { return ({
        getBillingSummary: builder.query({
            query: function (_a) {
                var clientId = _a.clientId;
                return (0, api_url_1.appendClientId)("/v1/billing", clientId);
            },
            providesTags: ["billing"],
        }),
        createPortalSession: builder.mutation({
            query: function (_a) {
                var returnTo = _a.returnTo, clientId = _a.clientId;
                return ({ url: "/v1/billing/portal-session", method: "POST", body: { returnTo: returnTo, client_id: clientId } });
            },
        }),
    }); },
});
exports.useGetBillingSummaryQuery = exports.billingApi.useGetBillingSummaryQuery, exports.useCreatePortalSessionMutation = exports.billingApi.useCreatePortalSessionMutation;
